/* RN PASS — motion trigger. Fires .rn-lit/.rn-occlude/.rn-hairline/
   .rn-stagger primitives (rn-motion.css) by adding .is-lit to
   [data-rn-pass] elements once they enter the viewport. One
   IntersectionObserver, no deps, no rAF loop, no scroll listener.
   Terminal: unobserve() after firing, never re-lights, never loops.
   Reads html[data-rn-motion="off"] and prefers-reduced-motion:reduce —
   in either case every target is lit immediately, unobserved, so the
   CSS frozen end-state applies from first paint. */

(function () {
  "use strict";

  var root = document.documentElement;
  var reduceMotion =
    window.matchMedia &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var motionOff = root.getAttribute("data-rn-motion") === "off";

  // Skip [data-rn-pass] elements nested inside another [data-rn-pass]
  // element: the CSS `.is-lit .rn-lit` rule lights them from the parent's
  // own trigger, so a redundant observer entry would fire them
  // independently and defeat the intended reveal order.
  var allTargets = document.querySelectorAll("[data-rn-pass]");
  var targets = [];
  for (var a = 0; a < allTargets.length; a++) {
    var cand = allTargets[a];
    if (cand.parentElement && cand.parentElement.closest("[data-rn-pass]")) {
      continue;
    }
    targets.push(cand);
  }

  // Assign --rn-i to .rn-stagger children so CSS can fan out reveal delay.
  var staggers = document.querySelectorAll(".rn-stagger");
  for (var s = 0; s < staggers.length; s++) {
    var kids = staggers[s].children;
    for (var c = 0; c < kids.length; c++) {
      kids[c].style.setProperty("--rn-i", c);
    }
  }

  function light(el) {
    el.classList.add("is-lit");
  }

  // Frozen fallback: light everything now, skip observation entirely.
  if (reduceMotion || motionOff) {
    for (var i = 0; i < targets.length; i++) light(targets[i]);
    for (var j = 0; j < staggers.length; j++) light(staggers[j]);
    return;
  }

  if (!("IntersectionObserver" in window) || targets.length === 0) {
    for (var k = 0; k < targets.length; k++) light(targets[k]);
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      for (var e = 0; e < entries.length; e++) {
        var entry = entries[e];
        if (!entry.isIntersecting) continue;

        var el = entry.target;
        el.style.willChange = "transform, background-position, opacity";
        light(el);
        observer.unobserve(el); // terminal: never re-fires

        el.addEventListener(
          "transitionend",
          function (ev) {
            if (ev.target === el) el.style.willChange = "auto";
          },
          { once: true }
        );
      }
    },
    { root: null, rootMargin: "0px 0px -10% 0px", threshold: 0.15 }
  );

  for (var t = 0; t < targets.length; t++) observer.observe(targets[t]);
})();
